import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companySearchPart = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/search/parts',

        partCategories: [],
        partCategoriesLoading: false,

        partBrands: [],
        partBrandsLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        partCategories: state => state.partCategories,

        partBrands: state => state.partBrands,

    },
};
